import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["contactCheckbox", "memberCount", "searchInput", "contactRow", "noResults"]

  connect() {
    this.updateMemberCount()
  }

  // Show only rows whose name/email contains the query (data-search is the
  // lowercased "name email"). Selection state is preserved while filtering.
  filter() {
    const q = (this.hasSearchInputTarget ? this.searchInputTarget.value : "").trim().toLowerCase()
    let visible = 0
    this.contactRowTargets.forEach((row) => {
      const match = !q || (row.dataset.search || "").includes(q)
      row.classList.toggle("d-none", !match)
      if (match) visible++
    })
    if (this.hasNoResultsTarget) this.noResultsTarget.classList.toggle("d-none", visible !== 0)
  }

  toggleContact(event) {
    this.updateMemberCount()
  }

  updateMemberCount() {
    if (this.hasMemberCountTarget) {
      const selectedCount = this.contactCheckboxTargets.filter(checkbox => checkbox.checked).length
      this.memberCountTarget.textContent = selectedCount
    }
  }

  selectAll(event) {
    event.preventDefault()
    // Only select rows currently visible (respects an active search filter).
    this.contactCheckboxTargets.forEach(checkbox => {
      const row = checkbox.closest(".contact-selection-item")
      if (!row || !row.classList.contains("d-none")) checkbox.checked = true
    })
    this.updateMemberCount()
  }

  deselectAll(event) {
    event.preventDefault()
    this.contactCheckboxTargets.forEach(checkbox => {
      checkbox.checked = false
    })
    this.updateMemberCount()
  }
}